import React from "react";
import { getBadgeToneStyle } from "../badgeStyles";
import { cx } from "../utils";

/**
 * CcEvaluationCard — timeline evaluation entry with bordered detail card.
 */
const CcEvaluationCard = ({
  at,
  timestamp,
  evaluator,
  status,
  statusTone = "info",
  reason,
  note,
  goals = [],
  footer = [],
  isLast = false,
  clickable = false,
  onClick,
  className,
  ...props
}) => {
  const toneStyle = getBadgeToneStyle(statusTone);
  const hasFooter = footer.length > 0;
  const hasBody = reason || note || goals.length > 0;
  const isButton = Boolean(clickable && onClick);
  const CardRoot = isButton ? "button" : "article";

  return (
    <div
      className={cx(
        "cc-evaluation-entry",
        isLast && "cc-evaluation-entry--last",
        className,
      )}
    >
      <span className="cc-evaluation-entry__track" aria-hidden>
        <span className="cc-evaluation-entry__dot" />
        {!isLast ? <span className="cc-evaluation-entry__line" /> : null}
      </span>

      <CardRoot
        type={isButton ? "button" : undefined}
        className={cx(
          "cc-evaluation-card",
          isButton && "cc-evaluation-card--clickable",
        )}
        onClick={isButton ? onClick : undefined}
        {...props}
      >
        {timestamp ? (
          <time className="cc-evaluation-card__timestamp" dateTime={at}>
            {timestamp}
          </time>
        ) : null}

        {evaluator ? (
          <p className="cc-evaluation-card__evaluator">{evaluator}</p>
        ) : null}

        {status ? (
          <span
            className={cx(
              "cc-evaluation-card__status",
              `cc-evaluation-card__status--${statusTone}`,
            )}
            style={{
              backgroundColor: toneStyle.background,
              color: toneStyle.color,
            }}
          >
            {status}
          </span>
        ) : null}

        {reason ? (
          <p className="cc-evaluation-card__reason">
            <span className="cc-evaluation-card__label">Reason:</span> {reason}
          </p>
        ) : null}

        {note ? <p className="cc-evaluation-card__note">{note}</p> : null}

        {goals.length > 0 ? (
          <ul
            style={{
              listStyle: "none",
              margin: "8px 0 0",
              padding: 0,
              display: "flex",
              flexDirection: "column",
              gap: 6,
            }}
          >
            {goals.map((g, i) => {
              const gTone = getBadgeToneStyle(g.statusTone || "info");
              return (
                <li
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  {g.status ? (
                    <span
                      style={{
                        fontSize: 10.5,
                        fontWeight: 700,
                        borderRadius: 6,
                        padding: "1px 7px",
                        whiteSpace: "nowrap",
                        backgroundColor: gTone.background,
                        color: gTone.color,
                      }}
                    >
                      {g.status}
                    </span>
                  ) : null}
                  <span style={{ fontSize: 13 }}>{g.text}</span>
                  {g.note ? (
                    <span
                      style={{ fontSize: 12, color: "#7C7770", width: "100%" }}
                    >
                      {g.note}
                    </span>
                  ) : null}
                </li>
              );
            })}
          </ul>
        ) : null}

        {hasFooter && hasBody ? (
          <hr className="cc-evaluation-card__divider" />
        ) : null}

        {hasFooter ? (
          <dl className="cc-evaluation-card__footer">
            {footer.map(({ label, value }) =>
              label && value ? (
                <div key={label} className="cc-evaluation-card__meta-row">
                  <dt className="cc-evaluation-card__meta-label">{label}</dt>
                  <dd className="cc-evaluation-card__meta-value">{value}</dd>
                </div>
              ) : null,
            )}
          </dl>
        ) : null}
      </CardRoot>
    </div>
  );
};

export default CcEvaluationCard;
